import React from 'react';
import { ReactMarkdownDisplay } from '../../../PageElements/ReactMarkdownDisplay';
import style from './SectionSubtitles.scss';

export const SectionSubtitles = ({ subtitle, prefix, pageName }) => (
  <div className={style.subtitle}>
    <ReactMarkdownDisplay
      markdown={subtitle}
      mdName={pageName}
      prefix={prefix}
    />
  </div>
);
